export default "__VITE_ASSET__557f23c9__"